'use client';

import { PropsWithChildren, useEffect, useState } from 'react';
import { ErrorBoundary } from '@appsignal/react';

import { AppSignalClient } from 'services/appSignal';
import { ClientConfig, type TClientConfig } from 'services/clientConfig';
import { ContextProviders, ContextProvidersProps } from './ContextProviders';

interface Props extends PropsWithChildren, ContextProvidersProps {
  clientConfig: TClientConfig;
}

export type ProvidersProps = Props;

export const Providers = (props: Props) => {
  const { clientConfig, children, ...rest } = props;

  const [isConfigReady, setIsConfigReady] = useState(false);

  useEffect(() => {
    ClientConfig.getInstance().setConfig(clientConfig);

    AppSignalClient.init();

    setIsConfigReady(true);
  }, [clientConfig]);

  if (!isConfigReady) return null;

  const appSignal = AppSignalClient.getInstance().getClient();

  return (
    <ErrorBoundary instance={appSignal}>
      <ContextProviders {...rest}>{children}</ContextProviders>
    </ErrorBoundary>
  );
};
